// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"faqs-module--mainContent--Wtjhh","mainContent__desc":"faqs-module--mainContent__desc--34CO8"};